import { useEffect } from 'react';
import { useDocs } from '../../../hooks/useDocs';

/**
 * Docs for /doc and /snippet pickers.
 * Use the host list when it already has one. Otherwise share the workspace
 * catalog — load once when the picker opens, never a private SopAPI.list().
 */
export function usePickerDocs(availableDocs) {
  const { docs, loading, error, reload } = useDocs({ eager: false });

  useEffect(() => {
    if (availableDocs !== null) return undefined;
    reload();
    return undefined;
  }, [availableDocs, reload]);

  if (availableDocs !== null) {
    return { docs: availableDocs, loadError: '' };
  }
  if (loading && docs.length === 0) {
    return { docs: null, loadError: error };
  }
  return { docs, loadError: error };
}
